import React from 'react';
import PageContainer from "../../container/CustomPage";

import PortfolioDashboard from "../../container/portfolio";

const ContentPortfolioPage = () => {
    return (
        <PageContainer classes={'bg-grey'}>
           <PortfolioDashboard type={'page'}/>
        </PageContainer>
    );
};

export default ContentPortfolioPage;